import { Fee } from "../models/fee";
import * as P from "../models/patient";
import { Patient } from "../models/patient";
import { PaymentRegistrationParams } from "../models/payment";
import { Registration, RegistrationState } from "../models/registration";
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export function getRegistrationFeeList(): Request {
  return {
    url: `${API_PREFIX}/blade-store/treatmentServiceCatalog/registrationFee/list`,
    method: "GET",
    params: {
      current: 0,
      size: 1000,
    },
  };
}

export interface RegistrationQueryParams {
  index?: number;
  current?: number;
  size?: number;
  param?: string;
  treatmentDepartmentId?: string;
  treatmentDoctorId?: string;
  registrationState?: RegistrationState;
  registrationTimeHead?: string;
  registrationTimeTail?: string;
}

export function getRegistrationList(params: RegistrationQueryParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/registration/list`,
    method: "GET",
    params: {
      ...params,
      index: undefined,
    },
  };
}

export interface RegisterParams {
  patient: Patient;
  registration: Registration;
  fee?: Fee;
  payment?: PaymentRegistrationParams;
}

export function register(params: RegisterParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/registration/save`,
    method: "POST",
    body: {
      patient: P.toJson(params.patient),
      registration: params.registration,
      treatmentServiceCatalog: params.fee,
      payment: params.payment,
    },
  };
}

export function cancelRegistration(registrationId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/registration/cancel`,
    method: "POST",
    params: {
      id: registrationId,
    },
  };
}

export function getRegistrationDetail(registrationId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/registration/detail`,
    method: "GET",
    params: {
      registrationId,
    },
  };
}

export function getRegistrationCounts(
  params: Record<string, unknown>
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/registration/count`,
    method: "GET",
    params,
  };
}

export function startTreatment(registrationId: string): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/registration/change`,
    method: "POST",
    params: {
      id: registrationId,
    },
  };
}
